/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { FilterCaseModel } from '../model/models';
import { UserProductBrandCategoryProductSelect } from '../model/models';
import { UserProductDetails } from '../model/models';
import { UserProductDetailsUpdate } from '../model/models';
import { UserProductOverView } from '../model/models';
import { UserProductPostPut } from '../model/models';
import { UserProductPostPutPagingResult } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class UserProductService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUpdateProductType(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiUpdateProductType(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiUpdateProductType(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiUpdateProductType(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiUpdateProductType.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/userProducts/Type/${encodeURIComponent(String(id))}`,
            null,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductByIdGet(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductPostPut>;
    public apiUserProductByIdGet(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductPostPut>>;
    public apiUserProductByIdGet(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductPostPut>>;
    public apiUserProductByIdGet(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiUserProductByIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<UserProductPostPut>(`${this.configuration.basePath}/api/userProducts/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves list brand, category, product, repairshop select in order to create new user product
     * @param isGetHide 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsBrandCategoryProductSelectGet(isGetHide?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductBrandCategoryProductSelect>;
    public apiUserProductsBrandCategoryProductSelectGet(isGetHide?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductBrandCategoryProductSelect>>;
    public apiUserProductsBrandCategoryProductSelectGet(isGetHide?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductBrandCategoryProductSelect>>;
    public apiUserProductsBrandCategoryProductSelectGet(isGetHide?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (isGetHide !== undefined && isGetHide !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isGetHide, 'isGetHide');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<UserProductBrandCategoryProductSelect>(`${this.configuration.basePath}/api/userProducts/brandCategoryProductSelect`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a specific user product by userProductId
     * @param userProductId userProductId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsByUserProductIdDelete(userProductId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiUserProductsByUserProductIdDelete(userProductId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiUserProductsByUserProductIdDelete(userProductId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiUserProductsByUserProductIdDelete(userProductId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (userProductId === null || userProductId === undefined) {
            throw new Error('Required parameter userProductId was null or undefined when calling apiUserProductsByUserProductIdDelete.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/api/userProducts/${encodeURIComponent(String(userProductId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an existed user product
     * @param userProductId userProductId
     * @param userProductPostPut user product info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsByUserProductIdPut(userProductId: number, userProductPostPut?: UserProductPostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiUserProductsByUserProductIdPut(userProductId: number, userProductPostPut?: UserProductPostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiUserProductsByUserProductIdPut(userProductId: number, userProductPostPut?: UserProductPostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiUserProductsByUserProductIdPut(userProductId: number, userProductPostPut?: UserProductPostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (userProductId === null || userProductId === undefined) {
            throw new Error('Required parameter userProductId was null or undefined when calling apiUserProductsByUserProductIdPut.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/userProducts/${encodeURIComponent(String(userProductId))}`,
            userProductPostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a specific user product by userProductId
     * @param userProductId userProductId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsDetailsByUserProductIdGet(userProductId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductDetails>;
    public apiUserProductsDetailsByUserProductIdGet(userProductId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductDetails>>;
    public apiUserProductsDetailsByUserProductIdGet(userProductId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductDetails>>;
    public apiUserProductsDetailsByUserProductIdGet(userProductId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userProductId === null || userProductId === undefined) {
            throw new Error('Required parameter userProductId was null or undefined when calling apiUserProductsDetailsByUserProductIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<UserProductDetails>(`${this.configuration.basePath}/api/userProducts/details/${encodeURIComponent(String(userProductId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a specific user product by userProductId detailsUpdate
     * @param userProductId userProductId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsDetailsUpdateByUserProductIdGet(userProductId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductDetailsUpdate>;
    public apiUserProductsDetailsUpdateByUserProductIdGet(userProductId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductDetailsUpdate>>;
    public apiUserProductsDetailsUpdateByUserProductIdGet(userProductId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductDetailsUpdate>>;
    public apiUserProductsDetailsUpdateByUserProductIdGet(userProductId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userProductId === null || userProductId === undefined) {
            throw new Error('Required parameter userProductId was null or undefined when calling apiUserProductsDetailsUpdateByUserProductIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<UserProductDetailsUpdate>(`${this.configuration.basePath}/api/userProducts/detailsUpdate/${encodeURIComponent(String(userProductId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves  user products of current user(customer)
     * @param filterCaseModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsMyUserProductsGet(filterCaseModel?: FilterCaseModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductPostPutPagingResult>;
    public apiUserProductsMyUserProductsGet(filterCaseModel?: FilterCaseModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductPostPutPagingResult>>;
    public apiUserProductsMyUserProductsGet(filterCaseModel?: FilterCaseModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductPostPutPagingResult>>;
    public apiUserProductsMyUserProductsGet(filterCaseModel?: FilterCaseModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<UserProductPostPutPagingResult>(`${this.configuration.basePath}/api/userProducts/myUserProducts`,
            filterCaseModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search user products of current user(customer)
     * @param filterCaseModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsMyUserProductsSearch(filterCaseModel?: FilterCaseModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductPostPutPagingResult>;
    public apiUserProductsMyUserProductsSearch(filterCaseModel?: FilterCaseModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductPostPutPagingResult>>;
    public apiUserProductsMyUserProductsSearch(filterCaseModel?: FilterCaseModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductPostPutPagingResult>>;
    public apiUserProductsMyUserProductsSearch(filterCaseModel?: FilterCaseModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<UserProductPostPutPagingResult>(`${this.configuration.basePath}/api/userProducts/searchShopBike`,
            filterCaseModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new user product
     * @param userProductPostPut user product info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsPost(userProductPostPut?: UserProductPostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductOverView>;
    public apiUserProductsPost(userProductPostPut?: UserProductPostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductOverView>>;
    public apiUserProductsPost(userProductPostPut?: UserProductPostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductOverView>>;
    public apiUserProductsPost(userProductPostPut?: UserProductPostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<UserProductOverView>(`${this.configuration.basePath}/api/userProducts`,
            userProductPostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param productName 
     * @param productBrandId 
     * @param productCategoryId 
     * @param productWarrantyPeriod 
     * @param customerId 
     * @param productId 
     * @param productProductId 
     * @param productBrandBrandId 
     * @param productBrandName 
     * @param productBrandIsActive 
     * @param productPhoto 
     * @param productItemNumber 
     * @param productType 
     * @param productYear 
     * @param productHidding 
     * @param categoryId 
     * @param frameNumber 
     * @param serialNumber 
     * @param billDateTick 
     * @param billNumber 
     * @param purchasedPlaceId 
     * @param billPhoto 
     * @param framePhotos 
     * @param serialPhotos 
     * @param isCancelled 
     * @param userProductId 
     * @param batteryNumber 
     * @param type 
     * @param bikeType 
     * @param photoUrl 
     * @param caseId 
     * @param isHaveOpenCase 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsPostWithForm(productName: string, productBrandId: number, productCategoryId: number, productWarrantyPeriod: number, customerId?: number, productId?: number, productProductId?: number, productBrandBrandId?: number, productBrandName?: string, productBrandIsActive?: boolean, productPhoto?: string, productItemNumber?: string, productType?: number, productYear?: number, productHidding?: boolean, categoryId?: number, frameNumber?: string, serialNumber?: string, billDateTick?: number, billNumber?: string, purchasedPlaceId?: number, billPhoto?: Blob, framePhotos?: Array<Blob>, serialPhotos?: Array<Blob>, isCancelled?: boolean, userProductId?: number, batteryNumber?: string, type?: number, bikeType?: number, photoUrl?: string, caseId?: number, isHaveOpenCase?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductOverView>;
    public apiUserProductsPostWithForm(productName: string, productBrandId: number, productCategoryId: number, productWarrantyPeriod: number, customerId?: number, productId?: number, productProductId?: number, productBrandBrandId?: number, productBrandName?: string, productBrandIsActive?: boolean, productPhoto?: string, productItemNumber?: string, productType?: number, productYear?: number, productHidding?: boolean, categoryId?: number, frameNumber?: string, serialNumber?: string, billDateTick?: number, billNumber?: string, purchasedPlaceId?: number, billPhoto?: Blob, framePhotos?: Array<Blob>, serialPhotos?: Array<Blob>, isCancelled?: boolean, userProductId?: number, batteryNumber?: string, type?: number, bikeType?: number, photoUrl?: string, caseId?: number, isHaveOpenCase?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductOverView>>;
    public apiUserProductsPostWithForm(productName: string, productBrandId: number, productCategoryId: number, productWarrantyPeriod: number, customerId?: number, productId?: number, productProductId?: number, productBrandBrandId?: number, productBrandName?: string, productBrandIsActive?: boolean, productPhoto?: string, productItemNumber?: string, productType?: number, productYear?: number, productHidding?: boolean, categoryId?: number, frameNumber?: string, serialNumber?: string, billDateTick?: number, billNumber?: string, purchasedPlaceId?: number, billPhoto?: Blob, framePhotos?: Array<Blob>, serialPhotos?: Array<Blob>, isCancelled?: boolean, userProductId?: number, batteryNumber?: string, type?: number, bikeType?: number, photoUrl?: string, caseId?: number, isHaveOpenCase?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductOverView>>;
    public apiUserProductsPostWithForm(productName: string, productBrandId: number, productCategoryId: number, productWarrantyPeriod: number, customerId?: number, productId?: number, productProductId?: number, productBrandBrandId?: number, productBrandName?: string, productBrandIsActive?: boolean, productPhoto?: string, productItemNumber?: string, productType?: number, productYear?: number, productHidding?: boolean, categoryId?: number, frameNumber?: string, serialNumber?: string, billDateTick?: number, billNumber?: string, purchasedPlaceId?: number, billPhoto?: Blob, framePhotos?: Array<Blob>, serialPhotos?: Array<Blob>, isCancelled?: boolean, userProductId?: number, batteryNumber?: string, type?: number, bikeType?: number, photoUrl?: string, caseId?: number, isHaveOpenCase?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (productName === null || productName === undefined) {
            throw new Error('Required parameter productName was null or undefined when calling apiUserProductsPostWithForm.');
        }
        if (productBrandId === null || productBrandId === undefined) {
            throw new Error('Required parameter productBrandId was null or undefined when calling apiUserProductsPostWithForm.');
        }
        if (productCategoryId === null || productCategoryId === undefined) {
            throw new Error('Required parameter productCategoryId was null or undefined when calling apiUserProductsPostWithForm.');
        }
        if (productWarrantyPeriod === null || productWarrantyPeriod === undefined) {
            throw new Error('Required parameter productWarrantyPeriod was null or undefined when calling apiUserProductsPostWithForm.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (customerId !== undefined) {
            formParams = formParams.append('CustomerId', <any>customerId) as any || formParams;
        }
        if (productId !== undefined) {
            formParams = formParams.append('ProductId', <any>productId) as any || formParams;
        }
        if (productProductId !== undefined) {
            formParams = formParams.append('Product.ProductId', <any>productProductId) as any || formParams;
        }
        if (productName !== undefined) {
            formParams = formParams.append('Product.Name', <any>productName) as any || formParams;
        }
        if (productBrandId !== undefined) {
            formParams = formParams.append('Product.BrandId', <any>productBrandId) as any || formParams;
        }
        if (productBrandBrandId !== undefined) {
            formParams = formParams.append('Product.Brand.BrandId', <any>productBrandBrandId) as any || formParams;
        }
        if (productBrandName !== undefined) {
            formParams = formParams.append('Product.Brand.Name', <any>productBrandName) as any || formParams;
        }
        if (productBrandIsActive !== undefined) {
            formParams = formParams.append('Product.Brand.IsActive', <any>productBrandIsActive) as any || formParams;
        }
        if (productCategoryId !== undefined) {
            formParams = formParams.append('Product.CategoryId', <any>productCategoryId) as any || formParams;
        }
        if (productPhoto !== undefined) {
            formParams = formParams.append('Product.Photo', <any>productPhoto) as any || formParams;
        }
        if (productWarrantyPeriod !== undefined) {
            formParams = formParams.append('Product.WarrantyPeriod', <any>productWarrantyPeriod) as any || formParams;
        }
        if (productItemNumber !== undefined) {
            formParams = formParams.append('Product.ItemNumber', <any>productItemNumber) as any || formParams;
        }
        if (productType !== undefined) {
            formParams = formParams.append('Product.Type', <any>productType) as any || formParams;
        }
        if (productYear !== undefined) {
            formParams = formParams.append('Product.Year', <any>productYear) as any || formParams;
        }
        if (productHidding !== undefined) {
            formParams = formParams.append('Product.Hidding', <any>productHidding) as any || formParams;
        }
        if (categoryId !== undefined) {
            formParams = formParams.append('CategoryId', <any>categoryId) as any || formParams;
        }
        if (frameNumber !== undefined) {
            formParams = formParams.append('FrameNumber', <any>frameNumber) as any || formParams;
        }
        if (serialNumber !== undefined) {
            formParams = formParams.append('SerialNumber', <any>serialNumber) as any || formParams;
        }
        if (billDateTick !== undefined) {
            formParams = formParams.append('BillDateTick', <any>billDateTick) as any || formParams;
        }
        if (billNumber !== undefined) {
            formParams = formParams.append('BillNumber', <any>billNumber) as any || formParams;
        }
        if (purchasedPlaceId !== undefined) {
            formParams = formParams.append('PurchasedPlaceId', <any>purchasedPlaceId) as any || formParams;
        }
        if (billPhoto !== undefined) {
            formParams = formParams.append('BillPhoto', <any>billPhoto) as any || formParams;
        }
        if (framePhotos) {
            if (useForm) {
                framePhotos.forEach((element) => {
                    formParams = formParams.append('FramePhotos', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('FramePhotos', framePhotos.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (serialPhotos) {
            if (useForm) {
                serialPhotos.forEach((element) => {
                    formParams = formParams.append('SerialPhotos', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('SerialPhotos', serialPhotos.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (isCancelled !== undefined) {
            formParams = formParams.append('IsCancelled', <any>isCancelled) as any || formParams;
        }
        if (userProductId !== undefined) {
            formParams = formParams.append('UserProductId', <any>userProductId) as any || formParams;
        }
        if (batteryNumber !== undefined) {
            formParams = formParams.append('BatteryNumber', <any>batteryNumber) as any || formParams;
        }
        if (type !== undefined) {
            formParams = formParams.append('Type', <any>type) as any || formParams;
        }
        if (bikeType !== undefined) {
            formParams = formParams.append('BikeType', <any>bikeType) as any || formParams;
        }
        if (photoUrl !== undefined) {
            formParams = formParams.append('PhotoUrl', <any>photoUrl) as any || formParams;
        }
        if (caseId !== undefined) {
            formParams = formParams.append('CaseId', <any>caseId) as any || formParams;
        }
        if (isHaveOpenCase !== undefined) {
            formParams = formParams.append('IsHaveOpenCase', <any>isHaveOpenCase) as any || formParams;
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<UserProductOverView>(`${this.configuration.basePath}/api/userProducts/Form`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new user product
     * @param userProductPostPut user product info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserProductsUserProductsCasePostPost(userProductPostPut?: UserProductPostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<UserProductOverView>;
    public apiUserProductsUserProductsCasePostPost(userProductPostPut?: UserProductPostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<UserProductOverView>>;
    public apiUserProductsUserProductsCasePostPost(userProductPostPut?: UserProductPostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<UserProductOverView>>;
    public apiUserProductsUserProductsCasePostPost(userProductPostPut?: UserProductPostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<UserProductOverView>(`${this.configuration.basePath}/api/userProducts/UserProductsCasePost`,
            userProductPostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
